import { colors, navigationLinks } from "./constants";
import { NavigationItem } from "./NavigationBar";
import { useScreenSize } from "../hooks/useScreenSize";
import { usePage } from "@inertiajs/react";
import LogoSvg from "./LogoSvg";
import AppAppearance from "./AppAppearance";
import { HideChromeButton, useChromePart } from "./ChromeVisibility";

function DesktopTopBar({ onHide }: { onHide: () => void }) {
  const { url } = usePage()
  return (
    <div>
      <div style={{
        width: '100%',
        backgroundColor: colors['background'],
        borderBottom: `1px solid ${colors['borderColor']}`,
        display: 'flex',
        gap: '32px',
        padding: '4px 8px',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          gap: '4px',
        }}>
          <LogoSvg
            color={colors['borderColor']}
          />
          <div style={{
            fontFamily: 'Times New Roman, serif',
            fontSize: '25px',
            color: colors['black'],
          }}>
            Maronite Hub
          </div>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
          }}>
            {navigationLinks.map((navigationLink) => (
              <NavigationItem
                key={navigationLink.href}
                icon={navigationLink.icon}
                label={navigationLink.label}
                selected={navigationLink.selected(url)}
                href={navigationLink.href}
                style={{
                  gap: '4px',
                  flex: 1,
                  aspectRatio: 'none',
                  padding: '4px 0px',
                  width: '125px',
                }}
              />
            ))}
          </div>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '8px',
        }}>
          <HideChromeButton
            onHide={onHide}
            label="Hide top bar"
            size={24}
            style={{ color: colors['borderColor'] }}
          />
        </div>
      </div>
    </div>
  )
}

function MobileTopBar() {
  return (
    <div>
      <div style={{
        width: '100%',
        // backgroundColor: colors['background'],
        backgroundColor: 'var(--active-button-background)',
        color: 'var(--active-button-text)',
        borderBottom: `1px solid ${colors['borderColor']}`,
        display: 'flex',
        gap: '4px',
        padding: '1px 0px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <LogoSvg
            color={'var(--active-button-text)'}
            height={35}
          />
          <div className="breadcrumbs text-sm [&_li+li:before]:opacity-100">
            <ul>
              <li className="link">Faith</li>
              <li>Bible</li>
            </ul>
          </div>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '4px',
          paddingRight: '4px',
        }}>
          <AppAppearance />
        </div>
      </div>
    </div>
  )
}

export default function AppTopBar() {
  const { screenLargerThan } = useScreenSize()
  const [hidden, setHidden] = useChromePart('topBar')

  if (hidden) { return null }

  const onHide = () => setHidden(true)

  return (
    screenLargerThan('lg') ? (
      <DesktopTopBar onHide={onHide} />
    ) : (
      <MobileTopBar />
    )
  )
}